module.exports = __webpack_public_path__ + "static/media/disruptops_logo_full.d3d16996.png";